export default __webpack_public_path__ + "2072a94dec4afdc2bb4720d7404fb6ae.js";